import { render } from "./ScenarioDetailPage.vue?vue&type=template&id=950b7542&scoped=true"
import script from "./ScenarioDetailPage.vue?vue&type=script&lang=js"
export * from "./ScenarioDetailPage.vue?vue&type=script&lang=js"

import "./ScenarioDetailPage.vue?vue&type=style&index=0&id=950b7542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950b7542"]])

export default __exports__